import NotFooterLayout from "layouts/NotFooterLayout";
import PrintShippingLabel from "components/PrintShippingLabel";

function PrintShippingLabelPage() {
  return (
    <NotFooterLayout namePage="พิมพ์ใบปะหน้าพัสดุ" >
      <div className="layout-content">
        <PrintShippingLabel />
      </div>
    </NotFooterLayout>
  );
}

export default PrintShippingLabelPage;
